/* =====================================================
   Maison de Tracé — Main JavaScript
   ===================================================== */

document.addEventListener('DOMContentLoaded', function () {

  // ---- ナビスクロール ----
  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 70);
    }, { passive: true });
  }

  // ---- ハンバーガーメニュー ----
  const hamburger  = document.getElementById('hamburger');
  const drawer     = document.getElementById('drawer');
  const overlay    = document.getElementById('drawerOverlay');
  const drawerClose = document.getElementById('drawerClose');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    if (hamburger) hamburger.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  window.closeDrawer = function () {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    if (hamburger) hamburger.classList.remove('open');
    document.body.style.overflow = '';
  };

  if (hamburger) hamburger.addEventListener('click', () => {
    drawer && drawer.classList.contains('open') ? closeDrawer() : openDrawer();
  });
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // ---- スムーススクロール ----
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const href = a.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ---- 横スクロール ドットインジケーター ----
  function initScrollDots(wrapperId, itemSelector, dotsId) {
    const wrapper = document.getElementById(wrapperId);
    const dotsEl  = document.getElementById(dotsId);
    if (!wrapper || !dotsEl) return;
    if (window.innerWidth > 768) return;

    const items = wrapper.querySelectorAll(itemSelector);
    if (items.length === 0) return;

    items.forEach((_, i) => {
      const dot = document.createElement('span');
      if (i === 0) dot.classList.add('active');
      dotsEl.appendChild(dot);
    });

    const dots = dotsEl.querySelectorAll('span');
    wrapper.addEventListener('scroll', () => {
      const itemWidth = items[0].getBoundingClientRect().width + 14;
      const index = Math.round(wrapper.scrollLeft / itemWidth);
      dots.forEach((d, i) => d.classList.toggle('active', i === index));
    }, { passive: true });
  }

  initScrollDots('productsScroll', '.mdt-products__item', 'productsDots');
  initScrollDots('makingScroll',   '.mdt-making__card',   'makingDots');
  initScrollDots('journalScroll',  '.mdt-journal__item',  'journalDots');

  // ---- スクロールフェードイン ----
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll(
    '.mdt-brand__container, .mdt-products__item, .mdt-making__card, .mdt-journal__item'
  ).forEach((el, i) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(28px)';
    el.style.transition = `opacity 0.65s ease ${i * 0.07}s, transform 0.65s ease ${i * 0.07}s`;
    observer.observe(el);
  });

  // ---- 商品画像サムネイル切り替え ----
  const thumbs = document.querySelectorAll('.mdt-product-page__thumb');
  const mainImage = document.getElementById('mainImage');
  if (thumbs.length && mainImage) {
    thumbs.forEach(btn => {
      btn.addEventListener('click', function () {
        const src = this.dataset.imgSrc;
        if (src) {
          mainImage.srcset = '';
          mainImage.src = src;
        }
        thumbs.forEach(el => el.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  // ---- カートカウント更新（PC テキスト＋モバイル バッジ）----
  function updateCartUI(count) {
    // PC: "Cart (n)"
    const cartText = document.querySelector('.mdt-nav__cart');
    if (cartText) cartText.textContent = `Cart (${count})`;

    // モバイル: バッジ
    const iconEl = document.querySelector('.mdt-nav__cart-icon');
    if (iconEl) {
      let badge = iconEl.querySelector('.mdt-nav__cart-badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'mdt-nav__cart-badge';
          iconEl.appendChild(badge);
        }
        badge.textContent = count;
      } else {
        if (badge) badge.remove();
      }
    }
  }

  // ---- カートに追加（Ajax対応） ----
  document.querySelectorAll('.mdt-products__cart-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const originalText = this.textContent.trim();
      this.textContent = '追加中...';
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(res => res.json())
      .then(() => fetch('/cart.js'))
      .then(res => res.json())
      .then(cart => {
        // A) ナビのカートUI即時更新
        updateCartUI(cart.item_count);

        // D) ボタンを「カートを見る →」に変化
        this.textContent = 'カートを見る →';
        this.disabled = false;
        this.classList.add('mdt-products__cart-btn--added');
        this.addEventListener('click', function goToCart() {
          window.location.href = '/cart';
        }, { once: true });
      })
      .catch(() => {
        this.textContent = '⚠ エラーが発生しました';
        this.disabled = false;
        setTimeout(() => {
          this.textContent = originalText;
        }, 2500);
      });
    });
  });

});

/* ==================== 言語切替バナー＆トグル（韓国対応ペンディング中・無効化） ==================== */
/* (function() {
  var pathname  = window.location.pathname;
  var isKoPage  = pathname.startsWith('/ko-ko/') || pathname === '/ko-ko';

  // 現在ページの対応言語URLを生成
  var jaUrl = isKoPage ? (pathname.replace('/ko-ko', '') || '/') : pathname;
  var koUrl = isKoPage ? pathname : '/ko-ko' + pathname;

  // --- 地球マーク：トグル切替 ---
  var toggle = document.getElementById('mdtLangToggle');
  var label  = document.getElementById('mdtLangLabel');
  if (toggle && label) {
    if (isKoPage) {
      toggle.href = jaUrl;
      toggle.setAttribute('aria-label', '日本語に切り替える');
      label.textContent = 'JP';
    } else {
      toggle.href = koUrl;
      toggle.setAttribute('aria-label', '한국어로 보기');
      label.textContent = 'KO';
    }
  }

  // --- バナー表示ロジック ---
  var lang  = (navigator.language || navigator.userLanguage || '').toLowerCase();
  var langs = (navigator.languages || [navigator.language || '']).map(function(l) { return l.toLowerCase(); });
  var isKorean = lang.startsWith('ko') || langs.some(function(l) { return l.startsWith('ko'); });

  if (isKoPage) {
    // 韓国語ページ：「日本語版へ」バナーを現在ページの日本語URLに設定
    var bannerKo  = document.getElementById('mdtLangBannerKo');
    var closeKo   = document.getElementById('mdtLangBannerKoClose');
    if (!bannerKo || !closeKo) return;
    if (sessionStorage.getItem('mdtLangBannerKoClosed')) return;

    var bannerKoLink = bannerKo.querySelector('a');
    if (bannerKoLink) bannerKoLink.href = jaUrl;

    bannerKo.style.display = 'flex';
    document.body.classList.add('lang-banner-visible');

    closeKo.addEventListener('click', function() {
      bannerKo.style.display = 'none';
      document.body.classList.remove('lang-banner-visible');
      sessionStorage.setItem('mdtLangBannerKoClosed', '1');
    });

  } else {
    // 日本語ページ：ブラウザ言語が韓国語なら「韓国語版へ」バナーを現在ページの韓国語URLに設定
    var bannerJa  = document.getElementById('mdtLangBannerJa');
    var closeJa   = document.getElementById('mdtLangBannerJaClose');
    if (!bannerJa || !closeJa) return;
    if (sessionStorage.getItem('mdtLangBannerJaClosed')) return;
    if (!isKorean) return;

    var bannerJaLink = bannerJa.querySelector('a');
    if (bannerJaLink) bannerJaLink.href = koUrl;

    bannerJa.style.display = 'flex';
    document.body.classList.add('lang-banner-visible');

    closeJa.addEventListener('click', function() {
      bannerJa.style.display = 'none';
      document.body.classList.remove('lang-banner-visible');
      sessionStorage.setItem('mdtLangBannerJaClosed', '1');
    });
  }
/* })(); */
